import { combineReducers } from 'redux';
import { localizeReducer as localize } from 'react-localize-redux';

import survey from './survey';
import surveySchema from './surveySchema';
import surveySchemaPart from './surveySchemaPart';
import messages from './messages';
import user from './user';
import pendingTasks from './pendingTasks';

const reducers = combineReducers({
  localize,
  user,
  survey,
  surveySchema,
  surveySchemaPart,
  messages,
  pendingTasks
});

export default reducers;
